import * as React from 'react';
import Layout from "../../../../Components/layouts";
import { CircularProgress, Grid, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CourseIframeToolbar from '../../../../Components/CourseIframeToolbar';
import { SkillsAndTransformation } from 'Services/SkillsAndTransformation';
import { CoursesServices } from 'Services/CoursesServices';
import { getSSOAuthUrl } from 'Services/AuthService';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import { BorderLinearProgress, BorderLinearProgressComplete } from 'Pages/UserAdmin/components/DynamicCard';
import { useHistory, useLocation } from "react-router-dom";
import { notify } from 'utils';
import { UserPath } from 'Routes/routePaths';
import { useAuthState } from 'Context';
import { DEFAULT_COURSE_IMAGE_URL, USER_ROLES, shouldOpenCourseInNewTab } from 'utils/constants';
import { withMoodleIdentityCheck } from 'utils/moodleSingleLogout';
import { useMoodleCourseIframeGuard } from 'hooks/useMoodleCourseIframeGuard';
import {
    isLearningHubAvailable,
    LEARNING_HUB_AVAILABILITY_EVENT,
} from 'utils/learningHubAvailability';


const skillsAndTransformation = new SkillsAndTransformation();
const courseServices = new CoursesServices();

export const calculatePercentage = (val, total) => {
    let percentage = parseFloat((val / total)) * 100;
    return percentage ? Math.floor(percentage) : 0;
}

const getCourseImageUrl = (course) =>
    (course?.imageUrl || course?.thumbnail_url || '').trim() || DEFAULT_COURSE_IMAGE_URL;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        minHeight: 180,
        background: '#FFFFFF',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        overflow: 'visible',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            height: 180,
            overflow: 'hidden',
        },
    },
    content: {
        flex: '1 1 0',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            maxWidth: '80%',
            overflow: 'hidden',
            minHeight: 0,
        },
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2, 2),
        },
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 1.5),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(3),
        },
    },
    cover: {
        width: '100%',
        height: 140,
        borderRadius: '5px 5px 0 0',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f0f0f0',
        '& img': {
            objectFit: 'contain',
        },
        [theme.breakpoints.up('sm')]: {
            width: 100,
            minWidth: 100,
            height: 132,
            paddingTop: 17,
            marginTop: 25,
            marginLeft: 12,
            borderRadius: 5,
            maxWidth: 'none',
            '& img': {
                objectFit: 'contain',
            },
        },
        [theme.breakpoints.up('md')]: {
            width: 174,
            minWidth: 174,
            marginLeft: 20,
        },
    },
    cardTitle: {
        color: "#808080"
    },
    cardSubtitle: {
        wordBreak: 'break-word',
        fontSize: '1.25rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: 'inherit',
        },
    },
    cardDesc: {
        color: "#808080",
        wordBreak: 'break-word',
        [theme.breakpoints.down('xs')]: {
            overflow: 'visible',
            display: 'block',
            WebkitLineClamp: 'unset',
            WebkitBoxOrient: 'unset',
        },
        [theme.breakpoints.up('sm')]: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
        },
    },
    cardContentInner: {
        height: 'auto',
        minHeight: 100,
        minWidth: 0,
        [theme.breakpoints.down('xs')]: {
            overflow: 'visible',
        },
        [theme.breakpoints.up('sm')]: {
            height: 180,
            overflow: 'auto',
        },
    },
    contentGrid: {
        flex: 1,
        minHeight: 0,
        [theme.breakpoints.up('sm')]: {
            alignItems: 'stretch',
            height: '100%',
            display: 'flex',
        },
    },
    buttonWrap: {
        margin: 'auto',
        width: '100%',
        marginTop: theme.spacing(1),
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
            width: 'auto',
            alignSelf: 'stretch',
            height: '100%',
            justifyContent: 'center',
        },
    },
    launchButton: {
        width: '100%',
        padding: '15px 45px',
        borderRadius: 10,
        maxWidth: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.only('sm')]: {
            padding: '12px 16px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '15px 45px',
        },
    },
    main: {
        padding: theme.spacing(2, 2),
        boxSizing: 'border-box',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 0),
        },
    },
    cardGridItem: {
        minWidth: 0,
    },
    tabsRoot: {
        marginBottom: theme.spacing(2),
        borderBottom: '1px solid #e0e0e0',
    },
    tabIndicator: {
        backgroundColor: theme.palette.primary.main,
    },
    fullWidthCourseWrap: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    iframeContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 30px rgba(12, 41, 84, 0.1)',
    },
    iframeContainerMaximized: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        width: '100%',
        height: '100%',
        borderRadius: 0,
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
    },
    loaderContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
        backgroundColor: '#fff',
    },
    courseIframe: {
        border: 'none',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
}));

const RegisteredCourses = () => {

    const classes = useStyles();
    const history = useHistory();
    const { userDetails } = useAuthState();
    const isUserRole = (userDetails?.role || USER_ROLES.USER) === USER_ROLES.USER;
    const [showLearningHubTab, setShowLearningHubTab] = React.useState(
        () => isUserRole && isLearningHubAvailable()
    );
    const [registerCourseList, setRegisterCourseList] = React.useState([]);
    const [loader, setLoader] = React.useState(false);
    const [emptyMessage, setEmptyMessage] = React.useState('');

    const [hubCourses, setHubCourses] = React.useState([]);
    const [hubLoader, setHubLoader] = React.useState(false);
    const [hubLoaded, setHubLoaded] = React.useState(false);

    const [iframeUrl, setIframeUrl] = React.useState('');
    const [isIframeVisible, setIsIframeVisible] = React.useState(false);
    const [iframeLoading, setIframeLoading] = React.useState(false);
    const [isMaximized, setIsMaximized] = React.useState(false);
    const iframeWrapRef = React.useRef(null);

    const openCourseInline = (url) => {
        setIframeUrl(url);
        setIframeLoading(true);
        setIsIframeVisible(true);
        setIsMaximized(false);
    };

    const openCourse = (url, provider) => {
        const launchUrl = withMoodleIdentityCheck(url);
        if (shouldOpenCourseInNewTab(provider)) {
            window.open(launchUrl, '_blank', 'noopener,noreferrer');
            return;
        }
        openCourseInline(launchUrl);
    };

    const closeCourseInline = () => {
        setIsIframeVisible(false);
        setIframeUrl('');
        setIsMaximized(false);
    };

    useMoodleCourseIframeGuard(closeCourseInline);

    const location = useLocation();

    React.useEffect(() => {
        setIsIframeVisible(false);
        setIframeUrl('');
        setIsMaximized(false);
    }, [location.pathname, location.key]);

    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get("type") || null;
    const isRegisteredCoursesRoute = location.pathname === UserPath.RegisteredCourses;
    const isMyLearningHubCoursesRoute = location.pathname === UserPath.MyLearningHubCourses;
    const activeTab = isMyLearningHubCoursesRoute ? 1 : 0;

    React.useEffect(() => {
        if (!isUserRole) {
            setShowLearningHubTab(false);
            return;
        }

        setShowLearningHubTab(isLearningHubAvailable());

        const handleAvailabilityChange = (event) => {
            setShowLearningHubTab(event.detail.available);
        };

        window.addEventListener(LEARNING_HUB_AVAILABILITY_EVENT, handleAvailabilityChange);
        return () => {
            window.removeEventListener(LEARNING_HUB_AVAILABILITY_EVENT, handleAvailabilityChange);
        };
    }, [isUserRole]);

    React.useEffect(() => {
        if (isMyLearningHubCoursesRoute && !showLearningHubTab) {
            history.replace(UserPath.RegisteredCourses);
        }
    }, [isMyLearningHubCoursesRoute, showLearningHubTab, history]);

    React.useEffect(() => {
        if (!isRegisteredCoursesRoute) {
            return;
        }

        setRegisterCourseList([]);
        setLoader(true);
        getAllRegisterCourse();
    }, [type, location.pathname]);

    React.useEffect(() => {
        if (!isMyLearningHubCoursesRoute || !showLearningHubTab || hubLoaded) {
            return;
        }

        let mounted = true;

        const fetchEnrolledLearningHubCourses = async () => {
            setHubLoader(true);
            const response = await skillsAndTransformation.getEnrolledLearningHubCourses();

            if (!mounted) {
                return;
            }

            if (response?.status) {
                setHubCourses(Array.isArray(response.data) ? response.data : []);
            } else {
                setHubCourses([]);
                notify('error', response?.message || 'Unable to load Learning Hub courses');
            }
            setHubLoader(false);
            setHubLoaded(true);
        };

        fetchEnrolledLearningHubCourses();

        return () => {
            mounted = false;
        };
    }, [isMyLearningHubCoursesRoute, showLearningHubTab, hubLoaded]);

    const filteredHubCourses = React.useMemo(() => {
        if (!type) {
            return hubCourses;
        }
        return hubCourses.filter((course) => {
            const score = parseFloat(course.course_completion_score) || 0;
            if (type === "inprogress") {
                return score < 100 && score > 0;
            }
            if (type === "completed") {
                return score >= 100;
            }
            return true;
        });
    }, [hubCourses, type]);

    const hubEmptyMessage = type === "inprogress"
        ? "No Courses In-Progress"
        : type === "completed"
            ? "No Courses Completed"
            : "No Learning Hub Courses Enrolled";

    const handleLaunchHubCourse = (course) => {
        if (course?.goto_url) {
            openCourse(course.goto_url, course.provider);
        } else {
            notify('error', 'Launch URL is not available for this course');
        }
    };

    const handleTabChange = (event, newValue) => {
        const nextPath = newValue === 1 ? UserPath.MyLearningHubCourses : UserPath.RegisteredCourses;

        // Preserve other query params like `type` but remove legacy `tab`.
        const nextParams = new URLSearchParams(location.search);
        nextParams.delete('tab');

        history.push({
            pathname: nextPath,
            search: nextParams.toString() ? `?${nextParams.toString()}` : '',
        });
    };

    const getAllRegisterCourse = async () => {
        const courseList = await skillsAndTransformation.getRegisterCourse();
        if (courseList.status) {
            setLoader(false);
            const courseArr = [];
            courseList.data?.courses.forEach((cat) => {
                if (cat.category !== 'Work readiness') {
                    cat.data.forEach((item) => {
                        let { course, labs } = item;
                        let obj = {
                            isLab: false,
                            title: course.category,
                            subTitle: course.course_name,
                            desc: course.description,
                            total: 100,
                            value: course.course_completion,
                            width: 12,
                            page: 'registeredCourse',
                            progress: true,
                            provider: course.provider,
                            ...course,
                            image: getCourseImageUrl(course),
                        };
                        if (type === "inprogress" && parseFloat(course.course_completion) < 100 && parseFloat(course.course_completion) > 0) {
                            courseArr.push(obj);
                        } else if (type === "completed" && parseFloat(course.course_completion) >= 100) {
                            courseArr.push(obj);
                        } else if (type === null) {
                            courseArr.push(obj);
                        }
                        if (labs && labs.length) {
                            labs.forEach((course) => {
                                let obj = {
                                    title: course.vendor,
                                    subTitle: course.name,
                                    desc: course.description,
                                    total: 100,
                                    value: course.course_completion,
                                    width: 12,
                                    page: 'registeredCourse',
                                    progress: true,
                                    isLab: true,
                                    provider: course.provider,
                                    ...course,
                                    image: getCourseImageUrl(course),
                                }
                                if (type === "inprogress" && parseFloat(course.course_completion) < 100 && parseFloat(course.course_completion) > 0) {
                                    courseArr.push(obj);
                                } else if (type === "completed" && parseFloat(course.course_completion) >= 100) {
                                    courseArr.push(obj);
                                } else if (type === null) {
                                    courseArr.push(obj);
                                }
                            });
                        }
                    });
                }
            });
            if (type === "inprogress" && !courseArr.length) {
                setEmptyMessage("No Courses In-Progress");
            } else if (type === "completed" && !courseArr.length) {
                setEmptyMessage("No Courses Completed");
            } else {
                setEmptyMessage('');
            }
            setRegisterCourseList(courseArr);
        }
    }

    const handleLinkURL = async (itm) => {
        const { link, token, course_id_talent_lms, course_id, uuid, category, provider } = itm;
        if (itm.isLab && uuid) {
            const results = await courseServices.getLabLaunchURL({ ResourceId: uuid });
            if (results?.data?.Token) {
                openCourse(results?.data?.Token, provider);
            } else {
                notify("error", "Lab Launch URL is not found!");
            }
            return results;
        }
        if (course_id_talent_lms) {
            try {
                courseServices.getSessionLinkToCourse(course_id)
                    .then(({ goto_url }) => {
                        if (goto_url) {
                            openCourse(goto_url, provider);
                        } else {
                            notify("error", "Launch URL is not found for this course!");
                            return null;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } catch (error) {
                // Send push notification
                console.error(error);
            }
        } else if (provider === 'Revinova') {
            const resolvedUrl = getSSOAuthUrl(link, 'Deviare', category);
            if (resolvedUrl) {
                openCourse(resolvedUrl, provider);
            } else {
                notify("error", "Launch URL is not found for this course!");
            }
        }
        else {
            const resolvedUrl = getSSOAuthUrl(link, 'simplilearn', category);
            if (resolvedUrl) {
                openCourse(resolvedUrl, provider);
            } else {
                notify("error", "Launch URL is not found for this course!");
            }
        }
    };

    return (
        <Layout lockPageScroll={isIframeVisible}>
            {isIframeVisible ? (
                <div className={classes.fullWidthCourseWrap}>
                    <div
                        className={`${classes.iframeContainer}${isMaximized ? ` ${classes.iframeContainerMaximized}` : ''}`}
                        ref={iframeWrapRef}
                    >
                        <CourseIframeToolbar
                            isMaximized={isMaximized}
                            onToggleMaximize={() => setIsMaximized((prev) => !prev)}
                            onClose={closeCourseInline}
                        />
                        {iframeLoading && (
                            <div className={classes.loaderContainer}>
                                <CircularProgress color="primary" />
                            </div>
                        )}
                        <iframe
                            src={iframeUrl}
                            frameBorder="0"
                            title="Course"
                            className={classes.courseIframe}
                            allow="fullscreen; autoplay; picture-in-picture"
                            allowFullScreen
                            onLoad={() => setIframeLoading(false)}
                        ></iframe>
                    </div>
                </div>
            ) : (
                <main className={classes.main}>
                {showLearningHubTab && (
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        className={classes.tabsRoot}
                        classes={{ indicator: classes.tabIndicator }}
                    >
                        <Tab label="Registered Courses" />
                        <Tab label="My Learning Hub Courses" />
                    </Tabs>
                )}

                {activeTab === 0 && (
                    <Grid container spacing={2}>
                        {loader && <div style={{ marginTop: 30, textAlign: "center", width: "100%" }}>
                            <CircularProgress />
                        </div>}
                        {registerCourseList.length ? registerCourseList.map((item) => (
                            <Grid key={item.title} item xs={item.width} className={classes.cardGridItem}>
                                <Card className={classes.root} sx={{ display: "flex" }}>
                                    <CardMedia
                                        className={classes.cover}
                                        image={item.image}
                                        title={item.title}
                                    />
                                    <CardContent className={classes.content} style={{ display: 'flex', minWidth: 0 }}>
                                        <Grid container spacing={2} style={{ minWidth: 0 }} className={classes.contentGrid}>
                                            <Grid item xs={12} sm={9} className={classes.cardContentInner}>
                                                <Typography className={classes.cardTitle}>
                                                    {item.isLab ? <b>Lab</b> : item.title}
                                                </Typography>
                                                <Typography variant="h1" color="primary" className={classes.cardSubtitle}>
                                                    {item.subTitle}
                                                </Typography>
                                                <Typography className={classes.cardDesc} title={item.desc}>
                                                    {item.desc}
                                                </Typography>
                                                <Typography variant="h1" color="primary">
                                                    {item.totalCount}
                                                </Typography>

                                                {item.progress ? calculatePercentage(item.value, item.total) !== 100 ? <BorderLinearProgress variant="determinate" value={calculatePercentage(item.value, item.total)} /> :
                                                    <BorderLinearProgressComplete variant="determinate" value={calculatePercentage(item.value, item.total)} /> : null}

                                                <Typography style={{ fontSize: 13, color: "#808080" }} color="primary">
                                                    {calculatePercentage(item.value, item.total) + "% " + "completed"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={3} className={classes.buttonWrap}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => handleLinkURL(item)}
                                                    className={classes.launchButton}>
                                                    {parseFloat(item.value) > 0 ? (
                                                        "Continue learning"
                                                    ) : (
                                                        "LAUNCH"
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )) : (!loader) ? <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography variant='h4' >{emptyMessage || 'No Course Registered!'}</Typography>
                        </Grid> : null}
                    </Grid>
                )}

                {activeTab === 1 && showLearningHubTab && (
                    <Grid container spacing={2}>
                        {hubLoader && <div style={{ marginTop: 30, textAlign: "center", width: "100%" }}>
                            <CircularProgress />
                        </div>}
                        {!hubLoader && filteredHubCourses.length ? filteredHubCourses.map((course) => {
                            const completionScore = parseFloat(course.course_completion_score) || 0;
                            return (
                                <Grid key={course.uuid || course.name} item xs={12} className={classes.cardGridItem}>
                                    <Card className={classes.root} sx={{ display: "flex" }}>
                                        <CardMedia
                                            className={classes.cover}
                                            image={getCourseImageUrl(course)}
                                            title={course.name}
                                        />
                                        <CardContent className={classes.content} style={{ display: 'flex', minWidth: 0 }}>
                                            <Grid container spacing={2} style={{ minWidth: 0 }} className={classes.contentGrid}>
                                                <Grid item xs={12} sm={9} className={classes.cardContentInner}>
                                                    {course.provider && (
                                                        <Typography className={classes.cardTitle}>
                                                            {course.provider}
                                                        </Typography>
                                                    )}
                                                    <Typography variant="h1" color="primary" className={classes.cardSubtitle}>
                                                        {course.name}
                                                    </Typography>
                                                    <Typography className={classes.cardDesc} title={course.description}>
                                                        {course.description || 'Description not available'}
                                                    </Typography>

                                                    {calculatePercentage(completionScore, 100) !== 100 ? <BorderLinearProgress variant="determinate" value={calculatePercentage(completionScore, 100)} /> :
                                                        <BorderLinearProgressComplete variant="determinate" value={calculatePercentage(completionScore, 100)} />}

                                                    <Typography style={{ fontSize: 13, color: "#808080" }} color="primary">
                                                        {calculatePercentage(completionScore, 100) + "% " + "completed"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={3} className={classes.buttonWrap}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => handleLaunchHubCourse(course)}
                                                        className={classes.launchButton}>
                                                        {completionScore > 0 ? "Continue learning" : "LAUNCH"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        }) : (!hubLoader && hubLoaded) ? <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography variant='h4'>{hubEmptyMessage}</Typography>
                        </Grid> : null}
                    </Grid>
                )}
                </main>
            )}
        </Layout>
    );
}

export default RegisteredCourses;